module.exports = __webpack_public_path__ + "static/media/icon_check_active.a8b91018.svg";